import { useI18n } from 'hooks/useI18n';
import React from 'react';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../../shared/methodologyAnchor/MethodologyAnchor';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { GENDERSALARYBYEXPERIENCE } from '../Gender.constants';

const GenderSalaryByExperience: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');

  return (
    <div>
      <StyledRecharts className="gender">
        <ResponsiveContainer height={450} width={500} minWidth={500}>
          <BarChart data={GENDERSALARYBYEXPERIENCE}>
            <XAxis
              type="category"
              dataKey="exp"
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              tickLine={false}
              width={60}
              axisLine={false}
              tickMargin={5}
              tickFormatter={(tick) => {
                return `€${tick}K`;
              }}
              padding={{ bottom: 20 }}
            />
            <Tooltip
              cursor={{ fill: '#d9ceff' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `€${value.toFixed(1)}K`}
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: -5 }}
            />
            <Bar
              dataKey="female"
              name={t('mandecar23.gender.females')}
              barSize={12}
              radius={5}
              fill="#746FB3"
            ></Bar>
            <Bar
              dataKey="male"
              name={t('mandecar23.gender.males')}
              barSize={12}
              radius={5}
              fill="#1B9D76"
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default GenderSalaryByExperience;
